<template>
  <div class="slider-outer relative h-[100svh] w-full overflow-hidden">
    <transition-group name="mv-fade">
      <div v-for="(slide, index) in slides" v-show="state.currentSlide === index" :key="index" class="absolute h-[100svh] w-full">
        <!-- SP/PC 出し分け・最適化・preload は OptimizedImage が担当（picture の media でブラウザが選択し、JS の isSp で src を差し替えない） -->
        <OptimizedImage
          alt=""
          :class="['slider__img h-full w-full origin-left object-cover']"
          :pc-image-url="slide.pc"
          :pc-optimized-image-options="pcOptimizedImageOptions"
          :preload="preloadFirst && index === 0"
          :sp-image-url="slide.sp"
          :sp-optimized-image-options="spOptimizedImageOptions"
        />
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts" setup>
import { OptimizedImage } from '@/wabunka-src/common/components';
import type { OptimizeImageOptions } from '@/wabunka-src/common/utils/image/imageOptimizer';

interface State {
  currentSlide: number;
}

/** 1スライドあたりの SP/PC 画像の生URL（最適化は OptimizedImage が行う） */
interface Slide {
  sp: string;
  pc: string;
}

interface Props {
  slides: Slide[];
  /** SP 用の画像変換オプション（width など） */
  spOptimizedImageOptions?: OptimizeImageOptions;
  /** PC 用の画像変換オプション（width など） */
  pcOptimizedImageOptions?: OptimizeImageOptions;
  /** 先頭スライド(LCP候補)を <head> で preload する。ヒーロー(トップ/Destination等)で true にする */
  preloadFirst?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  spOptimizedImageOptions: () => ({}),
  pcOptimizedImageOptions: () => ({}),
  preloadFirst: false,
});

const state = reactive<State>({
  currentSlide: 0,
});

const slides = computed<Slide[]>(() => props.slides);

onMounted(async () => {
  await nextTick();
  setInterval(() => {
    state.currentSlide = (state.currentSlide + 1) % slides.value.length;
  }, 3500);
});
</script>

<style scoped lang="scss">
// 左側へゆっくり移動させる（img は OptimizedImage 内部にあるため :deep で届かせる）
:deep(.slider__img) {
  animation: slide 4.5s linear forwards;
}

@keyframes slide {
  0% {
    transform: scale(1.04) translateX(0);
  }
  100% {
    transform: scale(1.04) translateX(-3%);
  }
}

// 画像をフェードイン・アウトさせる
.mv-fade-enter-active,
.mv-fade-leave-active {
  transition: opacity 1s ease;
}

.mv-fade-enter-from,
.mv-fade-leave-to {
  opacity: 0;
}
</style>
